export default {
  title: "Ahabanza",
  active: "ukora",
  loading: "Birimo gutegurwa...",

  filters: {
    financialYear: "Umwaka w’Imari",
    from: "Kuva",
    to: "Kugeza",
  },

  actions: {
    refresh: "Ongera Ugaragaze",
  },

  fallback: {
    noEmail: "Nta imeyili",
    noPhone: "Nta telefone",
  },

  kpis: {
    openingBalance: "Amafaranga Yatangiranye",
    memberFunds: "Amafaranga y’Umunyamuryango",
    activeInvestedAmount: "Amafaranga Ari mu Ishoramari",
    loanEligibilityAmount: "Amafaranga Yemerewe Kugurizwa",
    outstandingLoanPrincipal: "Inguzanyo yose itarishyurwa",
    netMemberPosition: "Umutungo mbumbe",
    unpaidPenalties: "Ibihano Bitarishyurwa",
    unpaidItemsAcrossYears: "Hari ibihano {count} bitarishyurwa mu myaka yose.",
  },

  flows: {
    contributionsIn: "Imisanzu Yinjiye",
    outstandingLoanRepayments: "Inguzanyo Zitararangira",
    penaltyPaymentIn: "Ubwishyu bw’Ibihano",
    withdrawalsOut: "Amafaranga Yabikujwe",
    includesProfitWithdrawals: "Inyungu zabikujwe",
  },

  overdue: {
    title: "Ufite ibyiciro {count} by’inguzanyo byarengeje igihe.",
    amount: "Amafaranga yarengeje igihe",
    oldestDueDate: "Itariki ya kera kurusha izindi",
  },

  sections: {
    loans: "Inguzanyo",
    penalties: "Ibihano",
    investments: "Ishoramari",
    accountSummary: "Incamake ya Konti",
  },

  summary: {
    outstandingTotal: "Amafaranga Yose Atarishyurwa",
    outstandingPrincipal: "Umwenda wose",
    outstandingInterest: "Inyungu Zitarishyurwa",
    outstandingScope: "Inguzanyo Zirebwa",
    activeDefaultedCrossYear: "Inguzanyo zikora n’izarengeje igihe mu myaka yose",
    repaymentCards: "Ibyerekeye Ubwishyu",
    outstandingSelectedPeriod: "Inguzanyo zitararangira mu gihe cyahiswemo",
    activeLoans: "Inguzanyo Zikora",
    defaultedLoans: "Inguzanyo Zarengeje Igihe",
    overdueInstallments: "Ibyiciro Byarengeje Igihe",
    overdueAmount: "Amafaranga Yarengeje Igihe",
    oldestOverdueDate: "Itariki ya Kera Yarengeje Igihe",
    unpaidCount: "Umubare Utarishyurwa",
    unpaidAmount: "Amafaranga Atarishyurwa",
    createdThisPeriod: "Byashyizweho Muri Iki Gihe",
    paidThisPeriod: "Byishyuwe Muri Iki Gihe",
    waivedThisPeriod: "Byakuweho Muri Iki Gihe",
    ownedFunds: "Amafaranga Atunze",
    activeInvestedAmount: "Amafaranga Ari mu Ishoramari",
    loanEligibilityAmount: "Amafaranga Yemerewe Kugurizwa",
    availableShare: "Umugabane Uhari",
    openingBalance: "Amafaranga Yatangiranye",
    totalContributions: "Imisanzu Yose",
    totalWithdrawals: "Amafaranga Yose Yabikujwe",
    memberFunds: "Amafaranga y’Umunyamuryango",
    transactionsShown: "Ibikorwa Byagaragajwe",
  },

  details: {
    outstandingLoanCashRepayments: "Ubwishyu bw’Inguzanyo Zitararangira",
    repaymentsAppliedNote: "Ubwishyu bwashyizwe ku nguzanyo zikora n’izarengeje igihe muri iki gihe.",
    outstandingLoanPrincipalRepaid: "Inguzanyo yose yishyuwe",
    outstandingLoanInterest: "Inyungu kunguzanyo Zitararangira",
    repayment: "Ubwishyu",
    upfront: "Yakuwe Mbere",
    profitIn: "Inyungu Yinjiye",
  },

  transactions: {
    title: "Ibikorwa Biheruka",
    subtitle: "Ibikorwa biheruka ku nyandiko yawe y’imari.",
    records: "Ibikorwa {count}",
    loadingDashboard: "Ahabanza harimo gutegurwa...",
    empty: "Nta bikorwa biheruka byabonetse.",
    columns: {
      date: "Itariki",
      type: "Ubwoko",
      reference: "Indangagikorwa",
      amount: "Amafaranga",
    },
  },

  transactionTypes: {
    contribution: "Umusanzu",
    contributionReversal: "Gusubiza Inyuma Umusanzu",
    contributionUndo: "Gukuraho Umusanzu",
    loanRepayment: "Ubwishyu bw’Inguzanyo",
    loanRepaymentReversal: "Gusubiza Inyuma Ubwishyu bw’Inguzanyo",
    loanRepaymentUndo: "Gukuraho Ubwishyu bw’Inguzanyo",
    profit: "Inyungu",
    profitReversal: "Gusubiza Inyuma Inyungu",
    profitWithdrawal: "Kubikuza Inyungu",
    profitWithdrawalReversal: "Gusubiza Inyuma Kubikuza Inyungu",
    profitWithdrawalUndo: "Gukuraho Kubikuza Inyungu",
    profitUndo: "Gukuraho Inyungu",
    penaltyPayment: "Ubwishyu bw’Igihano",
    penaltyPaymentReversal: "Gusubiza Inyuma Ubwishyu bw’Igihano",
    penaltyPaymentUndo: "Gukuraho Ubwishyu bw’Igihano",
    loanDisbursement: "Gutanga Inguzanyo",
    migratedOpeningLoan: "Inguzanyo Yimuwe",
    openingBalance: "Amafaranga Yatangiranye",
    upfrontLoanInterest: "Inyungu y’Inguzanyo Yakuwe Mbere",
    partialWithdrawal: "Kubikuza Igice",
    exitWithdrawal: "Kubikuza Usohotse mu Itsinda",
    transaction: "Igikorwa",
  },

  errors: {
    loadFinancialYears: "Gufungura imyaka y’imari byanze.",
    selectFinancialYear: "Hitamo umwaka w’imari.",
    selectBothDates: "Hitamo itariki yo gutangira n’iyo kurangira.",
    rangeWithinFinancialYear:
      "Amatariki wahisemo agomba kuba mu mwaka w’imari wahisemo.",
    startBeforeEnd:
      "Itariki yo gutangira ntigomba kurenga iyo kurangira.",
    loadDashboard: "Gufungura ahabanza byanze.",
    periodOutsideFinancialYear:
      "Igihe wasabye ntikiri mu mwaka w’imari wahisemo.",
  },
};
